import { crud } from '@think-internet/zeus-frontend-package'

const props = {
  ...crud.Features,
  COOKIE_CONSENT: 'COOKIE_CONSENT',
}

export default props
